import {useEffect, useState} from 'react'

/**
 * Lazy loads a Google Font only when the component mounts
 * @param fontFamily - The font family name (e.g., 'Mrs Saint Delafield')
 * @param fontUrl - The Google Fonts URL
 * @returns boolean indicating if the font is loaded
 */
export const useLazyLoadFont = (fontFamily: string, fontUrl: string): boolean => {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    // Check if font is already loaded
    const existingLink = document.querySelector(`link[href="${fontUrl}"]`)
    if (existingLink) {
      setIsLoaded(true)
      return
    }

    // Create and append the font link
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = fontUrl

    link.onload = () => {
      setIsLoaded(true)
    }

    link.onerror = () => {
      console.error(`Failed to load font: ${fontFamily}`)
      setIsLoaded(false)
    }

    document.head.appendChild(link)

    // Cleanup function
    return () => {
      // Don't remove the link on unmount - keep it cached for future use
    }
  }, [fontFamily, fontUrl])

  return isLoaded
}
